import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Globe } from 'lucide-react';
import { services, waymining } from '../../data/services';
import '../../styles/Company.css';

const CompanyFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="company-footer" id="contact">
      <div className="company-footer-container">
        <div className="company-footer-brand">
          <span className="company-brand-mark">WM</span>
          <h3>Waymining</h3>
          <p>Mining technology &amp; safety services for South African and Mozambican operations.</p>
          <div className="company-footer-contact">
            <span><Mail size={16} /> comercial@waymining.co.mz</span>
            <span><Globe size={16} /> www.waymining.co.mz</span>
          </div>
        </div>

        <div className="company-footer-col">
          <h4>Products</h4>
          <Link to={waymining.path}>{waymining.name}</Link>
        </div>

        <div className="company-footer-col">
          <h4>Services</h4>
          {services.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`}>
              {s.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="company-footer-bottom">
        © {year} Waymining. All rights reserved.
      </div>
    </footer>
  );
};

export default CompanyFooter;
